import angular from "angular";

angular
    .module('app')
    .component('commentDetail', {
        template: require('./comment-detail.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.comment = $ctrl.resolve.comment;
    };

}
